import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = () => ['managementCompany'];

const fetchCompanies = async () => {
  const res = await request.get(
    `/Request/companies`,
    null,
    'Не удалось загрузить управляющие компании'
  );
  return res;
};

const useCompaniesQuery = (options) => {
  const query = useQuery(key(), () => fetchCompanies(), options);

  return {
    data: query.data,
    loading: query.isLoading
  }
}

export { useCompaniesQuery }